import type { Context } from 'react'
import { createContext } from 'react'
import { INITIAL_SNACKBAR_CONTEXT } from './constants'
import type { SnackbarContextT } from './types'

const SnackbarContext: Context<SnackbarContextT> = createContext(INITIAL_SNACKBAR_CONTEXT)

export default SnackbarContext
